import { BaseAPIModel, fetcher } from '@weezevent/weezjs-core';
import { ArgumentError } from '../utils/errors';

export default class SubscriptionTicket extends BaseAPIModel {
    static listUrl({ organizationId, subscriptionId }) {
        if (!organizationId || !subscriptionId) {
            throw new ArgumentError('[Model][SubscriptionTicket] organizationId and subscriptionId are mandatory');
        }
        return `/ticket-imports/organizations/${organizationId}/subscriptions/${subscriptionId}/tickets`;
    }

    static resend_tickets({ organizationId, subscriptionId, subscription_link_id = null, ticket_ids = null }) {
        if (!organizationId || !subscriptionId) {
            throw new ArgumentError('[Model][SubscriptionTicket][resend_tickets] organizationId and subscriptionId are mandatory');
        }

        if (!subscription_link_id && (!ticket_ids || ticket_ids.length === 0)) {
            throw new ArgumentError('[Model][SubscriptionTicket][resend_tickets] Either subscription_link_id or ticket_ids is mandatory');
        }

        const url = `/ticket-imports/organizations/${organizationId}/subscriptions/${subscriptionId}/tickets/actions`;

        const config = {
            ...(subscription_link_id ? { subscription_link_id } : {}),
            ...(ticket_ids && ticket_ids.length ? { ticket_ids } : {})
        };

        return fetcher.post(url, {
            data: {
                type: 'resend_tickets',
                config
            }
        });
    }
}
